export default __webpack_public_path__ + "static/media/arrow_right.2bbd346c.svg";